<template>
	<div class="right_body"
  v-loading="pwdLoading"
  :element-loading-text="pwdLoadingTxt"
  >
  <list-btn
  :listArr="listArr"
  :sdata="sdata"
  @detail="detail"
  @edit="edit"
  @add="add"
  isAdd
  isEdit
  >
  <span class="btn set_role" @click.stop="setSole"><i class="iconfont">&#xe66c;</i>设置角色</span>
  <span class="btn reset_pwd" @click.stop="resetPwd"><i class="iconfont" style="font-size:16px;">&#xe628;</i>重置密码</span>
  </list-btn>

  <tab-list
  :tabList="listArr"
  :total="total"
  :pages="pages"
  :fromData="fromData"
  :columns="tabColumns"
  tabName="system-auth-user"
  @currentChange="currentChange"
  @changePages="changePages"
  @selectSdata="selectSdata">
  </tab-list>


  <!-- 新增 -->
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" v-dialogDrag>
    <el-form :model="userFrom" :rules="rules" ref="userFrom" label-width="90px">
      <el-form-item label="用户昵称"  prop="name">
        <el-input v-model="userFrom.name" placeholder="请输入用户昵称"></el-input>
      </el-form-item>
      <el-form-item label="用户编码"  prop="code">
        <el-input v-model="userFrom.code" placeholder="请输入用户编码"></el-input>
      </el-form-item>
      <el-form-item label="登录账号"  prop="account">
        <el-input v-model="userFrom.account" maxlength="15" show-word-limit placeholder="请输入登录账号" oninput="value=value.replace(/^[\u0391-\uFFE5]+$/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="手机"  prop="telephone">
        <el-input v-model="userFrom.telephone" maxlength="11" show-word-limit placeholder="请输入常用手机"></el-input>
      </el-form-item>
      <el-form-item label="邮箱"  prop="email">
        <el-input v-model="userFrom.email" placeholder="请输入常用邮箱"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click.stop="submitForm" v-loading="$store.state.isLoading" :isDisable="isDisable">确 定</el-button>
    </div>
  </el-dialog>

  <!-- 选择角色 -->
  <el-dialog title="角色设置" :visible.sync="dialogRole" v-dialogDrag>
    <el-form label-width="90px">
      <el-form-item label="角色选择"  prop="name">
        <el-select v-model="roleTxt" filterable placeholder="请选择" @change="roleSelect">
           <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId">
            </el-option>
          </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogRole = false">取 消</el-button>
      <el-button type="primary" @click.stop="submitRole" v-loading="$store.state.isLoading" :isDisable="isDisable">确 定</el-button>
    </div>
  </el-dialog>

	</div>
</template>

<script>
import {user,role,userRole} from 'api/auth.js'

import listBtn from 'components/btn/listBtn.vue';
import tabList from 'components/table/list.vue';

export default{
	components:{listBtn,tabList},
	data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.fromData.adjustPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
		return {
      pwdLoading:false,
      pwdLoadingTxt:"",
      isDisable:false,
      dialogFormVisible:false,
      dialogRole:false,
      roleTxt:"",
      dialogTitle:"",
      isComponentChild:false,
      userFrom:{},//提交信息
      roleFrom:{},
			sdata:{},
      listArr:[],//列表
      isEdit:false,//状态
      roleList:[],//用户角色列表
      pwdRules:{
        oriPassword: [
          {required: true,message: '请输入原密码',trigger: 'blur'},
          {min:5, max: 20, message: '密码长度在 5 - 20位字符',trigger: 'blur' }
        ],
        adjustPassword:[
          {required: true,message: '请输入新密码',trigger: 'blur'},
          {min:5, max: 20, message: '密码长度在 5 - 20位字符',trigger: 'blur' }
        ],
        confirmPassword:[
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      rules:{
        account:[
          {required: true, message: '请输入登录账号', trigger: 'blur' },
          {min:3, max:15, message:'请输入3-15位的英文字符', trigger: 'blur' },
        ],
        telephone:[
          {message: '请输入手机号', trigger: 'blur' },
          {pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码', trigger: 'blur' }
        ],
        email:[{
            message: '请输入邮箱地址',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur']
        }]
      },
      tabColumns:[
        {field: 'code', title: '用户编码', width:110,"sortable":true},
        {field: 'account', title: '登录账号', width:110,"sortable":true},
        {field: 'roleName', title: '用户角色', width:110,"sortable":true},
        {field: 'name', title: '用户昵称'},
        {field: 'telephone', title: '手机'},
        {field: 'email', title: '邮箱'},
        /* {field: 'maintainStatus', title: '状态', width: 80,
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return rowData.maintainStatus === 'X' ? "已删除" : "正常";
        }
        } */
      ],//表头字段
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				}
			}
		}
	},
	created(){
		this.getListArr();
	},
  updated:function(){

  },
	methods:{
		showErrorMsg(txt){
			this.$message.error(txt);
		},
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getListArr();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getListArr();
    },
    //角色的选择
    roleSelect(val){
      console.log(this.sdata,111);
      console.log(this.roleList,999);
      let obj = this.roleList.find(v=>v.roleId === val);
      if(obj){
        this.roleTxt = obj.roleName;
        this.roleFrom.roleId = val;
      }
      this.roleFrom.userId = this.sdata.userId;
      //console.log(val,6666);
    },
		//获取列表
		async getListArr(){
			let res = await this.$post(user.list,this.fromData);
      if(res.status && res.data.list){
        this.listArr = res.data.list;
        this.pages = res.data.pages;
        this.total = res.data.total;
      }else{
        this.listArr = [];
        this.pages = 0;
        this.total = 0;
      }

      let roleList = await this.$post(role.list,this.$store.state.getAllPage);
      if(roleList.status && roleList.data.list){
        this.roleList = roleList.data.list;
      }else{
        this.roleList = [];
      }
		},

		handleSelectChange(item,key){
			if(item.isChecked){
				item.isChecked = false;
				this.sdata = {};
			}else{
				this.sdata = item;
				this.sdata.index = key;
				item.isChecked = true;
				this.listArr.forEach((items)=>{
					if(items.supplierId != item.supplierId){
						items.isChecked = false;
					}
				});
				if(item.maintainStatus === 'X'){
					this.sdata.isDel = true;
				}else{
					this.sdata.isDel = false;
				}
			}
		},

    //搜索
    subSearch(){
      this.getListArr();
    },
		//详情
		detail(){
			if(!this.sdata.userId){
				this.$message.error('请选择要查看的');
				return;
			}
			//this.$router.push({name:'base-supplier-detail',params:{id:this.sdata.supplierId}});
		},
		//新增
		add(){
      this.isEdit = false;
      this.dialogTitle = "新增";
			this.dialogFormVisible = true;
		},
		//编辑
		edit(){
      this.isEdit = true;
      this.dialogTitle = "编辑";
			if(!this.sdata.userId){
				this.$message.error('请选择要编辑的');
				return;
			}
      this.dialogFormVisible = true;
      this.userFrom = JSON.parse(JSON.stringify(this.sdata));
		},
		//设置角色
    setSole(){
      if(!this.sdata.userId){
      	this.$message.error('请选择用户');
      	return;
      }
      this.dialogRole = true;
    },
    //重置密码
    resetPwd(){
      if(!this.sdata.userId){
      	this.$message.error('请选择用户');
      	return;
      }
      let vm = this;
      this.$confirm('确认要重置【 用户：'+this.sdata.account+' 】的密码么？', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.subRestPwd();
      }).catch(() => {
      });
    },
    //重置密码
    async subRestPwd(){
      this.pwdLoading = true;
      this.pwdLoadingTxt = "密码重置中...";
      let pwdFrom = {
        "account": this.sdata.account,
        "name": this.sdata.name,
        "userId":this.sdata.userId
      };
      let res = await this.$post(user.resetpwd,pwdFrom);
      this.pwdLoading = false;
      this.pwdLoadingTxt = "";
      if(res.status){
        let msgHtml = "<p style='text-align:center;'>"+res.msg+"</p>";
            msgHtml += '<p style="text-align:center;">用户密码：<span style="font-weight:bold;font-size:18px;">'+res.data.resetPwd+'</span></p>';
        this.$alert(msgHtml, '操作提示', {
          dangerouslyUseHTMLString:true,
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }else{
        this.$message.error(res.errorMsg);
      }
    },
    //提交
    submitForm(){
      let vm = this;
      this.$refs['userFrom'].validate(async (vaild)=>{
        if(vaild){
          let postUrl = user.add;
          if(this.isEdit) postUrl = user.modify;
          this.isDisable = true;
          let res = await this.$post(postUrl,this.userFrom);
          if(res.status){
            if(!this.isEdit){
              let msgHtml = "<p style='text-align:center;'>"+res.msg+"</p>";
                  msgHtml += '<p style="text-align:center;">用户密码：<span style="font-weight:bold;font-size:18px;">'+res.data.password+'</span></p>';
              this.$alert(msgHtml, '操作提示', {
                dangerouslyUseHTMLString:true,
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
            this.userFrom = {};
            this.dialogFormVisible = false;
            this.getListArr();
          }else{
            this.$message.error(res.errorMsg);
          }
        }else{
          return false;
        }
      });
    },
    //提交用户角色
    async submitRole(){
      if(!this.roleFrom.roleId){
        this.$message.error("请选择角色");
        return;
      }
      if(!this.roleFrom.userId || !this.roleFrom.roleId){
        this.$message.error("用户或角色信息丢失，请刷新后再试！");
        return;
      }
      let postUrl = userRole.add;
      if(this.isEdit) postUrl = userRole.modify;
      let res = await this.$post(postUrl,this.roleFrom);
      this.dialogRole = false;
      if(res.status){
        this.$message.success(res.msg);
        this.roleFrom = {};
        this.roleTxt = "";

      }else{
        this.$message.error(res.errorMsg);
      }

      /*
       */

    }

	}
}
</script>

<style>
</style>
